export default function (){
    return '<div class="d-flex apply-popup__wrapper" data-popup>\n' +
        '    <div class="apply-popup__image">\n' +
        '        <img src="https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/LoanProducts-Images/hfi/hfi-popup.png" alt="Apply Now" />\n' +
        '    </div>\n' +
        '    <div class="apply-popup__content" >\n' +
        '        <h2>SET UP A FREE HOMEFUNDIT PAGE</h2>\n' +
        '        <p>\n' +
        '            Select the team member you\n' +
        '            will be working with\n' +
        '        </p>\n' +
        '        <select title="Enter Loan Officers Name">\n' +
        '            <option value="" selected>Enter Loan Officers Name</option>\n' +
        '            {{#each items}}\n' +
        '                <option value="{{this.url}}">{{this.text}}</option>\n' +
        '            {{/each}}\n' +
        '        </select>\n' +
        '        <p class="error d-none" data-error>Please select loan</p> \n' +
        '        <span class="button-deep-see button-cmg " data-reload-loan>SUBMIT</span>\n' +
        '    </div>\n' +
        '</div>'
}